function initAutofillGuard(root = document) {
  root.querySelectorAll('[data-disable-autofill]').forEach((input) => {
    if (input.dataset.autofillGuardInitialized === 'true') return;

    input.dataset.autofillGuardInitialized = 'true';
    input.setAttribute('readonly', 'readonly');
    input.addEventListener('focus', () => input.removeAttribute('readonly'));
  });
}

document.addEventListener('DOMContentLoaded', () => initAutofillGuard());

export { initAutofillGuard };
